// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__3dPxw","expandIcon":"AccordionButton_expandIcon__1eViz","expanded":"AccordionButton_expanded__30F5D"};